module.exports = __webpack_public_path__ + "img/racecourse-mauritius-turf-1800.c3bcaa1f.svg";